import React from "react";

const CountryDropdown = ({ value, onChange, countries }) => {
  return (
    <div>
      <label className="block text-sm font-medium text-gray-700">
        Country <span className="text-red-500">*</span>
      </label>
      <select
        name="Country"
        value={value}
        onChange={onChange}
        className="w-full p-2 border border-gray-300 rounded mt-1"
      >
        <option value="">Select a country</option>
        {countries.map((country) => (
          <option key={country.id} value={country.name}>
            {country.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default CountryDropdown;
